export class ExpandableList {
  constructor(el) {
    this.list = el;
    this.trigger = el.querySelector(".js-expandable-list__trigger");

    if(!this.trigger) {
      return false;
    }

    this.open = this.trigger.getAttribute("aria-expanded") === "true";

    this.bindEvents();
  }

  bindEvents() {
    this.trigger.addEventListener("click", (e) => {
      if(this.open) {
        this.list.classList.remove("is-expanded");
        this.trigger.setAttribute("aria-expanded", "false");
      } else {
        this.list.classList.add("is-expanded");
        this.trigger.setAttribute("aria-expanded", "true");
      }
      this.open = !this.open;
    });
  }
}
